var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: ["replies_outer", _vm.depth === 0 ? "indent" : ""],
      attrs: { "data-depth": _vm.depth },
    },
    [
      _c("div", { staticClass: "c-comments__comment" }, [
        _c("img", {
          staticClass: "c-comments__img",
          attrs: {
            src: _vm.reply.user_avatar,
            alt: _vm.reply.user_name + " comment",
          },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "c-comments__content" }, [
          _c("div", { staticClass: "c-comments__user" }, [
            _c("p", [
              _c("a", { attrs: { href: "/u/" + _vm.reply.user_name } }, [
                _vm._v(_vm._s(_vm.reply.user_name)),
              ]),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm.parent_username
                      ? _vm.parent_username
                      : _vm.first_username
                  ) +
                  "\n                "
              ),
            ]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.reply.comment_created))]),
          ]),
          _vm._v(" "),
          _c("p", {
            staticClass: "u-m-t1 u-m-b1 c-comments__text",
            domProps: { innerHTML: _vm._s(_vm.reply.comment_text) },
          }),
          _vm._v(" "),
          _vm.reply.comment_image != ""
            ? _c("p", { staticClass: "u-m-t1 u-m-b3" }, [
                _c("img", {
                  attrs: {
                    src: _vm.reply.comment_image,
                    alt: _vm.reply.user_name + "comment",
                  },
                }),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "c-comments__cta" }, [
            _c("p", [
              _c(
                "a",
                {
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.commentReply.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("Reply")]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                on: {
                  click: function ($event) {
                    return _vm.saveCommentLike(_vm.reply.comment_id)
                  },
                },
              },
              [
                _c(
                  "svg",
                  {
                    class: { liked: _vm.userLiked > 0 },
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "24",
                      height: "21",
                      viewBox: "0 0 24 21",
                      fill: "none",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M11.728 19.8376C11.29 19.5766 1 13.3538 1 6.76474C1 3.58612 3.62739 1 6.85673 1C9.02896 1 10.9907 2.18834 12 4.00725C13.0093 2.18834 14.971 1 17.1433 1C20.3726 1 23 3.58612 23 6.76474C23 13.3538 12.71 19.5755 12.272 19.8376L12 20L11.728 19.8376Z",
                        stroke: "black",
                        "stroke-width": "1.5",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(_vm.commentLikes))]),
              ]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.showReplyBox
        ? _c(
            "div",
            [
              _c("comment-box", {
                attrs: { "parent-id": _vm.reply.comment_id },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.reply.replies, function (deepReply) {
        return _c("deep-replies", {
          key: deepReply.comment_id,
          attrs: {
            reply: deepReply,
            first_username: deepReply.user_name,
            depth: _vm.currentDepth,
          },
        })
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }